// Plain-language reference so staff understand every part of a PSR note.
export const NOTE_GUIDE = [
  {
    key: "goals_addressed",
    title: "Targeted PCP Goal / Objective",
    what: "The specific numbered goal from the member's Person-Centered Plan (PCP) that you worked on this week.",
    why: "Every billable PSR service must tie back to a PCP goal. If it doesn't connect to a goal, it isn't billable.",
    example: "Goal #2, Objective A: Independent Living / Safe Food Preparation.",
  },
  {
    key: "interventions",
    title: "Staff Interventions Provided (What Staff Did This Week)",
    what: "ACTIVE DELIVERY — what YOU actually did this week: the tools you used, the prompts you gave, the skill you taught, how many times. Past tense. Never copy the PCP wording ('staff will…').",
    why: "This is the heart of the note. It proves a skilled service happened and justifies the time billed. Interventions MUST change every week — the app blocks saving if they match last week.",
    example: "Staff facilitated two independent living skills groups on kitchen safety. Staff used a visual checklist to teach checking expiration dates and gave verbal prompts on safe knife handling during a snack-prep activity.",
  },
  {
    key: "member_response",
    title: "Member Response",
    what: "How the member engaged — what they could do on their own vs. with a prompt, and anything they said.",
    why: "Shows the service was effective and the member was engaged — reviewers look for this.",
    example: "Member independently identified two expired items; needed one reminder to wash the cutting board. Stated they feel more confident preparing lunch."
  },
  {
    key: "progress",
    title: "Progress Toward Goal",
    what: "Whether the member is moving closer to their goal — better, the same, or struggling.",
    why: "Demonstrates the service is medically necessary and is helping the member grow.",
    example: "Identified 2 of 3 expired items independently, up from 1 last week."
  },
  {
    key: "plan",
    title: "Plan for Next Week",
    what: "The specific skill or step you'll work on next week — this becomes the starting point for next week's note.",
    why: "Shows the service is ongoing and purposeful, not random.",
    example: "Next week: stove-top safety and heat management during the scheduled cooking group."
  },
  {
    key: "type_of_contact",
    title: "Type of Contact",
    what: "How you met: In-person, Telehealth, Phone, or Collateral (talking to someone on the member's behalf).",
    why: "Required on every note. Note: PSR (H2017) is delivered in person — telehealth is generally not billable for PSR.",
    example: "In-person",
  },
  {
    key: "place_of_service",
    title: "Place of Service",
    what: "Where the session happened.",
    why: "Required field that shows the service was delivered in an appropriate community setting.",
    example: "Member's home, community, or PSR site.",
  },
  {
    key: "duration_units",
    title: "Duration & Units",
    what: "Total minutes you spent, and the number of 15-minute units that equals.",
    why: "PSR bills in 15-minute units (H2017). 60 minutes = 4 units. Your note must justify the time.",
    example: "60 minutes = 4 units.",
  },
  {
    key: "member_info",
    title: "Member Name & ID / Record #",
    what: "The member's name and their Medicaid ID or record number.",
    why: "Required on every page of the record so the note is tied to the right person.",
    example: "James Carter · MCD-100238",
  },
  {
    key: "staff_info",
    title: "Staff Name & Credentials",
    what: "Your name and your job title or credential (e.g., Paraprofessional, AP, QP).",
    why: "Every note must be signed with your credential. A QP is NOT required to co-sign notes written by non-QP staff.",
    example: "Pat Reynolds, Paraprofessional",
  },
];

export const GUIDE_INTRO =
  "A PSR note tells the story of one session and proves it was a skilled, billable service tied to the member's plan. Tap any card below to learn what each part means and why it matters.";
